import "./FullWidthContainer.scss"
export default function FullWidthContainer({ title, value, unit, currency}) {
  return (
    <div className="full_width_tile_container">
      <div className="title">{title}</div>
      <div className="value">
        <span>{value}</span>
        <span className="unit">
          {unit === 'amount' ? currency : unit === 'count' ? "Nos" : unit === 'distance' ? 'kms' : ''}
        </span>
      </div>
    </div>
  );
}
